import React from "react";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";

const instructors = [
  {
    id: 1,
    name: "Hellan",
    subject: "Computer Science",
    image: "https://picsum.photos/400/550?random=501"
  },
  {
    id: 2,
    name: "Jackson",
    subject: "Mathematics",
    image: "https://picsum.photos/400/550?random=502"
  },
  {
    id: 3,
    name: "Dickinson",
    subject: "Commerce",
    image: "https://picsum.photos/400/550?random=503"
  },
  {
    id: 4,
    name: "Dorianelliott",
    subject: "Economics",
    image: "https://picsum.photos/400/550?random=504"
  }
// ,
//   {
//     id: 5,
//     name: "Dorianelliott",
//     subject: "Economics",
//     image: "https://picsum.photos/400/550?random=505"
//   }
];

const TeamCard1 = () => {
  return (<>
    <section className="ins-section">
      <p className="ins-subtitle">Skilled Instructor</p>
      <h2 className="ins-title">Introduce Our Life Coaches</h2>

      <div className="ins-container">
        {instructors.map((ins) => (
          <div className="ins-card" key={ins.id}>
            <div className="img-box">
              <img src={ins.image} alt={ins.name} />

              {/* Hover Social Icons */}
              <div className="icon-bar">
                <a href="#">  <FaFacebookF />
                            </a>
                <a href="#"><FaTwitter />
                           </a>
                <a href="#"> <FaInstagram />
                           </a>
                <a href="#"> <FaLinkedinIn />
                            </a>
              </div>
            </div>

            <div className="ins-info">
              <h3>{ins.name}</h3>
              <p>{ins.subject}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
    <style>{`.ins-section {
  text-align: center;
  padding: 60px 6%;
  font-family: "Segoe UI", sans-serif;
}

.ins-subtitle {
  font-size: 15px;
  font-weight: 600;
  color: rgba(144, 202, 249,1);
}

.ins-title {
  font-size: 28px;
  font-weight: 800;
  margin: 8px 0 40px;
}

/* Instructor Cards */
.ins-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 26px;
}

.ins-card {
  background: #fff;
  width: 250px;
  border-radius: 12px;
  box-shadow: 0 5px 18px rgba(0,0,0,0.08);
  transition: 0.3s ease;
  overflow: hidden;
}
  .ins-card:hover .img-box img{opacity:0.5}
.img-box {
  position: relative;
  overflow: hidden;
  height: 260px;
}

.img-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Social icons sliding up */
.icon-bar {
  position: absolute;
  bottom: -60px;
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 12px;
  transition: 0.35s ease;
}

.icon-bar a {
  width: 32px;
  height: 32px;
  background: #ffffff;
  color: #222222;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  font-size: 14px;
  transition: 0.25s;
}

.icon-bar a:hover {
  background: rgba(144, 202, 249,1);;
}

/* Slide-up effect on hover */
.ins-card:hover .icon-bar {
  bottom: 6px;
}
.ins-card:hover .ins-info {
  
  background: rgba(144, 202, 249,1);
  color: #222222;
}
  
.ins-card:hover h3 {
  
  color: #000000;
}
.ins-card:hover p {
  
  color: #ffffff;
}
/* Card bottom text */
.ins-info {
  padding: 14px 12px 22px;
}

.ins-info h3 {
  font-size: 18px;
  margin: 4px 0;
  font-weight: 700;
}

.ins-info p {
  color: #666;
  font-size: 14px;
}

/* Hover lift effect */
.ins-card:hover {
  transform: translateY(-6px);
}

/* Responsive */
@media (max-width: 600px) {
  .ins-card {
    width: 100%;
    max-width: 350px;
  }
}
`}</style>
 </> );
};

export default TeamCard1;
